<div class="terms-container">
  <div class="terms-container-top">
    <div class="logo">
      <img src="../../../assets/images/bwrm-logo.png" alt="BWRM">
    </div>

    <h1>Welcome to Prism</h1>

    <h5 *ngIf="(policy$ | async)">Please read and accept our <strong>terms and conditions</strong> to continue:</h5>
  </div>

  <mat-progress-bar class="tc-loader" *ngIf="!(policy$ | async)" color="primary" mode="indeterminate"></mat-progress-bar>

  <div class="terms-container-inner" *ngIf="(policy$ | async)">
    <div class="terms-content">
      <p>{{policy$ | async}}</p>
    </div>

    <div class="terms-buttons">
      <button class="btn cancel-btn" mat-button (click)="openCancelPolicyDialog()" [disabled]="disableAndShowLoader">Cancel</button>
      <button class="btn accept-btn loader" mat-raised-button
              (click)="acceptPolicy()"
              [disabled]="!(policy$ | async) || disableAndShowLoader">
        Accept
        <ng-template [ngIf]="disableAndShowLoader">
          <div class="lds-hourglass"></div>
        </ng-template>
      </button>
    </div>
  </div>
</div>